import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FlexLayoutModule } from '@angular/flex-layout';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE,MAT_DIALOG_DATA,MatDialogRef} from '@angular/material';
import { MomentDateModule, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatAutocompleteModule} from '@angular/material/autocomplete';

import { SigninComponent } from '../pages/signin/signin.component';
import { PageNotFoundComponent } from '../pages/404/404.component';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { FormsModule } from '@angular/forms';

import { HeaderComponent } from '../components/header/header.component';
import { ReactiveFormsModule } from '@angular/forms';

import { GlobalCfgService } from '../services/globalcfg.service';

import { MatTooltipModule } from '@angular/material/tooltip';
import { RequestInterceptor } from '../services/http-interceptor';

import { FileUploadModule } from 'ng2-file-upload';
import { Utils } from '../services/utils';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MessageService } from '../services/message.service';

import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireModule } from '@angular/fire';
import { ChartsModule, ThemeService } from 'ng2-charts';

import { LoaderComponent } from '../components/loader/loader.component';
import { LoaderService } from '../services/loader.service';

import { MatRadioModule } from '@angular/material/radio';
import { GlobalPipesModule } from './globalpipe.module';
import { SnackBarComponent } from '../components/snack-bar/snack-bar.component';
import { ManufacturerComponent } from '../pages/manufacturer-layout/manufacturer/manufacturer.component';
import { ManufacturerDashboardComponent } from '../components/manufacturer-dashboard/manufacturer-dashboard.component';
import { AppViewDirective } from '../pages/app-view.directive';
import { ProgressBarComponent } from '../components/progress-bar/progress-bar.component';
import { ProductsListComponent } from '../components/products-list/products-list.component';
import { IncidentsComponent } from '../components/incidents/incidents.component';
import { LocationsComponent } from '../components/locations/locations.component';
import { DynamicTableComponent } from '../components/dynamic-table/dynamic-table.component';
import { ExpiryReportComponent } from '../components/expiry-report/expiry-report.component';
import { RecallSimulationComponent } from '../components/recall-simulation/recall-simulation.component';
import { RecallReportComponent } from '../components/recall-report/recall-report.component';
import { ManageBatchComponent } from '../components/manage-batch/manage-batch.component';
import { DynamicFormViewComponent } from '../components/dynamic-form-view/dynamic-form-view.component';
import { DynamicFormComponent } from '../components/dynamic-form/dynamic-form.component';
import { FormDialogComponent } from '../components/form-dialog/form-dialog.component';
import { FieldGeneratorService } from '../services/field-generator.service';
import { FormGroupControlService } from '../services/formgroup-control.service';
import { ManageMedicineComponent } from '../components/manage-medicine/manage-medicine.component';
import { ManageLocationComponent } from '../components/manage-location/manage-location.component';
import { ChangePasswordComponent } from '../components/change-password/change-password.component';
import { MedicineDetailComponent } from '../components/medicine-detail/medicine-detail.component';
import { EventBusService } from '../services/event-bus.service';
import { MiscService } from '../services/misc.service';
import { ExpiryReportService } from '../services/expiry-report.services';
import { BatchService } from '../services/batch.services';
import { NotificationsService } from  '../services/notifications.service';
import { MedicineService } from '../services/medicine.services';
import { LocationService } from '../services/location.services';
import { RecallReportService } from '../services/recall-report.services';
import { DashboardService } from '../services/dashboard.services';
import { AddBatchDialogComponent } from '../components/add-batch/add-batch-dialog.component';
import { DatepickerComponent } from '../components/datepicker/datepicker.component'
import { AuthService } from '../services/auth.service';
import { UserService } from '../services/user.service';
import { ForgotPasswordComponent } from '../components/forgot-password/forgot-password.component';
import { BasicHeaderComponent } from '../components/basic-header/basic-header.component';
import { ResetPasswordComponent } from '../components/reset-password/reset-password.component';
import { LocationsDialogComponent } from '../components/locations-dialog/locations-dialog.component';
import { IncidentsDialogComponent } from '../components/incidents-dialog/incidents-dialog.component';
import { BatchDialogComponent } from '../components/batch-dialog/batch-dialog.component';
import { RecallReportDialogComponent } from '../components/recall-report-dialog/recall-report-dialog.component';
import { ExpiryReportDialogComponent } from '../components/expiry-report-dialog/expiry-report-dialog.component';
import { ConfirmationDialogComponent } from '../components/confirm-dialog/confirm-dialog.component';
import { MapComponent } from '../components/incidents-map/map.component';
import { GeoChartComponent } from '../components/incidents-geo-chart/geo-chart.component';
import { GridComponent } from '../components/incidents-grid/grid.component';
import { IncidentService } from '../services/incident.services';
import { ProvenanceMapComponent } from '../components/provenance-map/provenance-map.component';
import { EditProfileComponent } from '../components/edit-profile/edit-profile.component';
import { FileUploadService } from '../services/file-upload.service';
import { EpicsNewImportComponent } from 'src/components/epics-new-import/epics-new-import.component';
import {SliderModule} from 'primeng/slider';
import { ManageLabelComponent } from '../components/manage-label/manage-label.component';
import { ProductLabelDialogComponent } from '../components/manage-label/product-label/product-label.component';
import { ParentChildLabelDialogComponent } from '../components/manage-label/parent-child-label/parent-child-label.component';
import { UniqueProductLabelDialogComponent } from '../components/manage-label/unique-product-label/unique-product-label.component';
import { AccessDeniedDialogComponent } from '../components/access-denied-dialog/access-denied-dialog.component';
import { AdminComponent } from '../pages/admin-layout/admin/admin.component';
import { ManageAssetComponent } from '../components/manage-asset/manage-asset.component';
import { ManageTruckDialogComponent } from '../components/manage-asset/manage-truck/manage-truck.component';
import { ManageDeviceComponent } from '../components/manage-device/manage-device.component';
import { ManageManufacturerComponent } from 'src/components/manage-organisation/manage-organisation.component';
import { AddManufacturerDialogComponent } from 'src/components/manage-organisation/add-organisation/add-organisation.component';
import { AddProductDialogComponent } from 'src/components/add-product/add-product.component';
import { LabelScanService } from 'src/services/label-scan.service';
import { LinkDeviceDialogComponent } from '../components/manage-device/link-device-dialog/link-device-dialog.component';
import { SyncDevicesDialogComponent } from '../components/manage-device/sync-devices-dialog/sync-devices-dialog.component';
import { AddLocationComponent } from '../components/manage-location/add-location/add-location.component';
import { LiveTrackingComponent } from 'src/components/live-tracking/live-tracking.component';
import { TrackingComponent } from '../components/live-tracking/tracking/tracking.component';
import { DATE_FORMATS } from 'src/services/date-format';
import { FooterComponent } from 'src/components/footer/footer.component';
import { ManageRoleComponent } from 'src/components/manage-role/manage-role.component';
import { ManageUserComponent } from 'src/components/manage-user/manage-user.component';
import { UserComponent } from 'src/components/manage-user/user/user.component';
import { ManageChainComponent } from 'src/components/manage-chain/manage-chain.component';
import { ChainNodeComponent } from 'src/components/manage-chain/node/node.component';
import { PrintLabelComponent } from 'src/components/print-label/print-label.component';
import { PrintService } from 'src/services/print.service';
import { AlertComponent } from '../components/alert/alert.component';
import { ShowLabelComponent } from '../components/manage-label/show-label/show-label.component';
import { DistributorComponent } from '../pages/distributor-layout/distributor/distributor.component';
import { ItemsReceivedComponent } from '../components/items-received/items-received.component';
import { ItemsSentComponent } from '../components/items-sent/items-sent.component';
import { ManagePackageComponent } from '../components/manage-package/manage-package.component';
import { PackageChildrenComponent } from '../components/manage-package/package-children/package-children.component';
import { DistributionDialogComponent } from '../components/manage-batch/distribution-dialog/distribution-dialog.component';
import { BatchDistributionComponent } from '../components/manage-batch/batch-distribution/batch-distribution.component';
import { CreateExistingBatchLabelComponent } from 'src/components/manage-label/create-existing-batch-label/create-existing-batch-label.component';
import { environment } from 'src/environments/environment';
import { DeleteBatchComponent } from 'src/components/delete-batch/delete-batch.component';
import { ManageNotificationsComponent } from 'src/components/manage-notifications/manage-notifications.component'
import { ManageSegmentComponent } from  '../components/manage-segment/manage-segment.component';
import { AddSegmentDialogComponent } from '../components/manage-segment/add-segment-dialog/add-segment-dialog.component';
import { EditSegmentDialogComponent } from '../components/manage-segment/edit-segment-dialog/edit-segment-dialog.component';
import { AddNotificationComponent } from 'src/components/manage-notifications/add-notification/add-notification.component';
import { AdminLayoutComponent } from '../pages/admin-layout/admin-layout.component';
import { EditBatchDialogComponent } from 'src/components/edit-batch/edit-batch-dialog.component';
import { AdduserlistComponent } from '../components/manage-segment/adduserlist/adduserlist.component';
import { ContextMenuComponent } from 'src/components/context-menu/context-menu.component';
import { UserfcmkeyComponent } from "../components/manage-user/userfcmkey/userfcmkey.component";
import { UserlistSegmentComponent } from "../components/userlist-segment/userlist-segment.component";
// import { UserlistComponent } from "../components/userlist/userlist.component";
import { RequestNotificationDialogComponent } from '../components/request-notification-dialog/request-notification-dialog.component';
import { SearchAutoCompleteComponent } from 'src/components/manage-device/link-device-dialog/search-auto-complete/search-auto-complete.component';
import { ManufacturerLayoutComponent } from '../pages/manufacturer-layout/manufacturer-layout.component';
import { DistributorLayoutComponent } from '../pages/distributor-layout/distributor-layout.component';
import { SidenavbarViewService } from '../services/sidenavbar-view.service';
import { LiveTrackingChartComponent } from '../components/live-tracking/live-tracking-chart/live-tracking-chart.component';
import { ManageBillingComponent } from 'src/components/manage-billing/manage-billing.component';
import { SubscriptionService } from '../services/subscription.service';
import { ViewPlansComponent } from 'src/components/manage-billing/viewplans/view-plans.component';
import { BulkBatchLabelComponent } from 'src/components/manage-label/bulk-batch-label/bulk-batch-label.component';
import { ViewBatchComponent } from 'src/components/manage-label/bulk-batch-label/view-batch/view-batch.component';
import { ViewBulkBatchComponet } from 'src/components/manage-batch/view-bulk-batch/view-bulk-batch-dialog.component';
import { SetProductionQtyComponent } from 'src/components/manage-batch/set-production-qty/set-production-qty.component';
import { EditBatchLabelComponent } from 'src/components/manage-label/bulk-batch-label/edit-batch-label/edit-batch-label.component';
import { PreInnerBatchLabelComponent } from 'src/components/manage-label/bulk-batch-label/pre-inner-batch-label/pre-inner-batch-label.component';
import { IncidentChildrenComponent } from 'src/components/incidents-grid/incident-children/incident-children.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SigninComponent,
    PageNotFoundComponent,
    LoaderComponent,
    SnackBarComponent,
    ManufacturerComponent,
    ManufacturerDashboardComponent,
    AppViewDirective,
    // UserlistComponent,
    ProgressBarComponent,
    ProductsListComponent,
    IncidentsComponent,
    LocationsComponent,
    DynamicTableComponent,
    ExpiryReportComponent,
    RecallSimulationComponent,
    RecallReportComponent,
    ManageBatchComponent,
    DynamicFormViewComponent,
    DynamicFormComponent,
    FormDialogComponent,
    ManageMedicineComponent,
    ManageLocationComponent,
    ChangePasswordComponent,
    MedicineDetailComponent,
    AddBatchDialogComponent,
    EditBatchDialogComponent,
    ContextMenuComponent,
    ForgotPasswordComponent,
    BasicHeaderComponent,
    ResetPasswordComponent,
    LocationsDialogComponent,
    IncidentsDialogComponent,
    BatchDialogComponent,
    DatepickerComponent ,
    AddSegmentDialogComponent ,
    RecallReportDialogComponent,
    ExpiryReportDialogComponent,
    ConfirmationDialogComponent,
    MapComponent,
    // NewbrandComponent,
    AdduserlistComponent,
    GeoChartComponent,
    GridComponent,
    ProvenanceMapComponent,
    EditProfileComponent,
    ManageLabelComponent,
    ProductLabelDialogComponent,
    ParentChildLabelDialogComponent,
    UniqueProductLabelDialogComponent,
    AccessDeniedDialogComponent,
    AdminComponent,
    AdminLayoutComponent,
    UserfcmkeyComponent,
    ManageAssetComponent,
    ManageTruckDialogComponent,
    ManageDeviceComponent,
    ManageManufacturerComponent,
    AddManufacturerDialogComponent,
    AddProductDialogComponent,
    LinkDeviceDialogComponent,
    SyncDevicesDialogComponent,
    AddLocationComponent,
    LiveTrackingComponent,
    TrackingComponent,
    FooterComponent,
    ManageNotificationsComponent,
    EditSegmentDialogComponent,
    ManageRoleComponent,
    ManageUserComponent,
    EpicsNewImportComponent,
    UserComponent,
    ManageChainComponent,
    ChainNodeComponent,
    PrintLabelComponent,
    AlertComponent,
    ShowLabelComponent,
    DistributorComponent,
    ItemsReceivedComponent,
    ItemsSentComponent,
    ManagePackageComponent,
    PackageChildrenComponent,
    DistributionDialogComponent,
    BatchDistributionComponent,
    CreateExistingBatchLabelComponent,
    DeleteBatchComponent,
    ManageSegmentComponent,
    AddNotificationComponent,
    UserlistSegmentComponent,
    RequestNotificationDialogComponent,
    SearchAutoCompleteComponent,
    ManufacturerLayoutComponent,
    DistributorLayoutComponent,
    LiveTrackingChartComponent,
    ManageBillingComponent,
    ViewPlansComponent,
    BulkBatchLabelComponent,
    ViewBatchComponent,
    ViewBulkBatchComponet,
    EditBatchLabelComponent,
    PreInnerBatchLabelComponent,
    IncidentChildrenComponent,
    SetProductionQtyComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    MatToolbarModule,
    MatGridListModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatBadgeModule,
    MatTableModule,
    MatPaginatorModule,
    MatTabsModule,
    MatCardModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatExpansionModule,
    MatButtonToggleModule,
    MatSortModule,
    MatDividerModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatListModule,
    MatTooltipModule,
    FileUploadModule,
    MatSnackBarModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    GlobalPipesModule,
    MatSlideToggleModule,
    MatSidenavModule,
    SliderModule,
    MatAutocompleteModule,
    MomentDateModule,
    AngularFireAuthModule,
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(environment.firebase),
    ChartsModule,
    MatProgressSpinnerModule
  ],
  providers: [
    MatNativeDateModule,
    GlobalCfgService,
    Utils,
    MessageService,
    LoaderService,
    FieldGeneratorService,
    FormGroupControlService,
    EventBusService,
    MiscService,
    ExpiryReportService,
    BatchService,
    NotificationsService,
    MedicineService,
    LocationService,
    RecallReportService,
    DashboardService,
    AuthService,
    UserService,
    IncidentService,
    FileUploadService,
    LabelScanService,
    PrintService,
    { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 10000 } },
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS},
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
    SidenavbarViewService,
    ThemeService,
    SubscriptionService
  ],
  entryComponents: [
    SnackBarComponent,
    ManufacturerDashboardComponent,
    ProgressBarComponent,
    ProductsListComponent,
    IncidentsComponent,
    LocationsComponent,
    ExpiryReportComponent,
    RecallSimulationComponent,
    EditSegmentDialogComponent,
    // UserlistComponent,
    RecallReportComponent,
    ManageBatchComponent,
    FormDialogComponent,
    ManageMedicineComponent,
    ManageLocationComponent,
    ChangePasswordComponent,
    EpicsNewImportComponent,
    MedicineDetailComponent,
    AddBatchDialogComponent,
    EditBatchDialogComponent,
    UserfcmkeyComponent,
    ContextMenuComponent,
    ForgotPasswordComponent,
    LocationsDialogComponent,
    IncidentsDialogComponent,
    ManageNotificationsComponent,
    BatchDialogComponent,
    RecallReportDialogComponent,
    ExpiryReportDialogComponent,
    ConfirmationDialogComponent,
    ProvenanceMapComponent,
    EditProfileComponent,
    ManageLabelComponent,
    ManageSegmentComponent,
    ProductLabelDialogComponent,
    ParentChildLabelDialogComponent,
    UniqueProductLabelDialogComponent,
    AccessDeniedDialogComponent,
    ManageAssetComponent,
    ManageTruckDialogComponent,
    ManageDeviceComponent,
    ManageManufacturerComponent,
    AddManufacturerDialogComponent,
    AddProductDialogComponent,
    LinkDeviceDialogComponent,
    SyncDevicesDialogComponent,
    AddLocationComponent,
    LiveTrackingComponent,
    TrackingComponent,
    AddSegmentDialogComponent,
    ManageRoleComponent,
    ManageUserComponent,
    UserComponent,
    ManageChainComponent,
    ChainNodeComponent,
    PrintLabelComponent,
    AlertComponent,
    ShowLabelComponent,
    DistributorComponent,
    ItemsReceivedComponent,
    ItemsSentComponent,
    ManagePackageComponent,
    PackageChildrenComponent,
    DistributionDialogComponent,
    BatchDistributionComponent,
    CreateExistingBatchLabelComponent,
    AdduserlistComponent,
    DeleteBatchComponent,
    AddNotificationComponent,
    RequestNotificationDialogComponent,
    LiveTrackingChartComponent,
    ManageBillingComponent,
    ViewPlansComponent,
    BulkBatchLabelComponent,
    ViewBatchComponent,
    ViewBulkBatchComponet,
    EditBatchLabelComponent,
    PreInnerBatchLabelComponent,
    IncidentChildrenComponent,
    SetProductionQtyComponent,
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }
